module.exports = __webpack_public_path__ + "img/7.b5e8b357.jpg";